import Reference from './Reference';

const Origin = props => {
  return <Reference {...props} />;
};

export default Origin;
